import { Avatar } from '@kinesis/bungle';
import type {
  Identity,
  UserIdentity,
  OrganisationIdentity,
  ServiceAccountIdentity,
} from '@/types';

type AvatarMagnitude = 'medium' | 'small' | 'xsmall' | 'large' | 'xlarge';

const userAvatar = (v: UserIdentity, magnitude: AvatarMagnitude = 'small') => (
  <Avatar magnitude={magnitude} variant='individual'>
    {v.initials}
  </Avatar>
);

const organisationAvatar = (
  v: OrganisationIdentity,
  magnitude: AvatarMagnitude = 'small',
) => (
  <Avatar magnitude={magnitude} variant='organisation' image={v.avatar}>
    {v.initial}
  </Avatar>
);

const serviceAccountAvatar = (
  v: ServiceAccountIdentity,
  magnitude: AvatarMagnitude = 'small',
) => (
  <Avatar magnitude={magnitude} variant='connection'>
    {v.initial}
  </Avatar>
);

const identityAvatar = (v: Identity, magnitude: AvatarMagnitude = 'small') => {
  switch (v.type) {
    case 'organisation':
      return organisationAvatar(v, magnitude);
    case 'user':
      return userAvatar(v, magnitude);
    case 'service-account':
      return serviceAccountAvatar(v, magnitude);
  }
};

export { userAvatar, organisationAvatar, serviceAccountAvatar, identityAvatar };
